import * as Sentry from '@sentry/react';
import { JSX, ReactNode, Suspense } from 'react';
import { useLocation } from 'react-router';

import { Spinner } from './spinner';
import { Button } from './button';

export const ErrorFallback = (props: { resetError: () => void }) => {
  const { resetError } = props;
  return (
    <div className="text-center flex flex-col items-center">
      <div>Something went wrong</div>
      <div className="text-sm text-zinc-500 mb-1">Please try again later</div>
      <div>
        <Button size="xs" onClick={resetError}>
          Try again
        </Button>
      </div>
    </div>
  );
};

export const SuspenseBoundary = ({
  children,
  className,
  fallback,
  loadingFallback,
}: {
  children: ReactNode;
  className?: string;
  fallback?: JSX.Element;
  loadingFallback?: ReactNode;
}) => {
  const location = useLocation();
  const errorFallback = fallback || ErrorFallback;

  return (
    <Sentry.ErrorBoundary
      onError={(e) => {
        console.error(e);
      }}
      fallback={errorFallback}
      key={location.pathname}
    >
      <Suspense
        fallback={
          loadingFallback || (
            <div className="grid place-content-center p-2">
              <Spinner className={className} />
            </div>
          )
        }
      >
        {children}
      </Suspense>
    </Sentry.ErrorBoundary>
  );
};
